module.exports = __webpack_public_path__ + "static/media/video.a00db2e0.mp4";